import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { DrawerPopup } from 'components/UI/DrawerPopup';
import { SuccessState } from 'components/UI/SuccessState'
import { ProductCard } from 'components/productCard';
import { ICertificateFullInfo } from '@repo/types';

type GenericSuccessDrawerProps = {
  open: boolean;
  onClose: () => void;
  certificate: ICertificateFullInfo;
  onViewCertificate?: () => void;
  onCloseAll?: () => void;
  drawerTitle: string;
  bodyTitle: string;
  description: string;
  buttonLabel: string;
};

export const GenericSuccessDrawer: React.FC<GenericSuccessDrawerProps> = ({
  open,
  onClose,
  certificate,
  onViewCertificate,
  drawerTitle,
  bodyTitle,
  description,
  buttonLabel,
}) => {
  return (
    <DrawerPopup
      title={drawerTitle}
      rightActionLabel='Done'
      rightActionOnClick={() => {
        onClose();
      }}
      handleOpen={open}
      handleClose={onClose}
      child={
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: 480, height: '100%' }}>
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              py: 4,
            }}
          >
            {/* VERA-315: the shared badge — same circle, same faint edge, same
                spinner-then-draw as every other success in the app (this is the
                VERA-304 gift/scan confirmation). It previously drew a static
                SVG check in a borderless disc, arriving fully formed. */}
            {/* Gated on `open`: DrawerPopup keeps its child mounted while
                closed, so an ungated SuccessState would start (and finish) its
                spinner at page load and show a static check when the sheet
                finally opens. Mounting it with the sheet is what makes the
                spinner-then-draw actually play. */}
            <Stack spacing={1} alignItems='center'>
              {open && <SuccessState title={bodyTitle} description={description} />}
              <ProductCard
                sx={{
                  marginTop: '24px !important',
                }}
                product={certificate.product}
              />
            </Stack>
          </Box>

          <Box sx={theme => ({ px: 2, pb: 2 })}></Box>

          <Box
            sx={{
              position: 'sticky',
              bottom: 0,
              left: 0,
              right: 0,
              p: 2,
              backgroundColor: theme => theme.palette.background.paper,
            }}
          >
            <Button
              fullWidth
              variant='contained'
              onClick={() => {
                onClose();
                onViewCertificate && onViewCertificate();
              }}
              sx={theme => ({
                backgroundColor: theme.palette.common.black,
                color: theme.palette.common.white,
                py: 1.5,
                '&:hover': { backgroundColor: theme.palette.grey[800] },
              })}
            >
              {buttonLabel}
            </Button>
          </Box>
        </Box>
      }
    />
  );
};
